import script from "./Success.vue?vue&type=script&setup=true&lang=ts"
export * from "./Success.vue?vue&type=script&setup=true&lang=ts"

import "./Success.vue?vue&type=style&index=0&id=2d0883e6&scoped=true&lang=css"

import exportComponent from "/data/liulv-h5/bj-International-card-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d0883e6"]])

export default __exports__